import Immutable from 'immutable';
import { homeSliderList } from '../../data/homeSlider';

const homeSliderItems = (state = new Immutable.Map(), action) => {
  return state.merge(
    Immutable.fromJS(
      homeSliderList.reduce((map, property) => {
        map[property.id] = property;
        return map;
      }, {})
    )
  );
};

export default homeSliderItems;
